import React from 'react';

const LocalStorageFallback = () => {
    const handleOpenInBrowser = () => {
        const targetUrl = window?.location?.href || '/';
        window.open(targetUrl, '_blank');
    };

    return (
        <div className='local-storage-fallback'>
            <div className='local-storage-fallback__card'>
                <p className='mb-4'>
                    Pentru a continua, această pagină trebuie deschisă în browser.
                </p>
                <button
                    type='button'
                    className='btn btn-primary btn-lg w-100 local-storage-fallback__button'
                    onClick={handleOpenInBrowser}
                >
                    Deschide în browser
                    <i className='bi bi-box-arrow-up-right ms-2' aria-hidden='true' />
                </button>
            </div>
        </div>
    );
};

export default LocalStorageFallback;
